import jwtDecode from "jwt-decode";

// **  Initial State
const initialState = {
    token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
    user_id: '',
    firstName: '',
    lastName: '',
    fullName: '',
    phone: '',
    suspend: '',
    wallet_price: '',
    roles: [],
    permissions: []
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN':
            let user;
            try {
                user = jwtDecode(action.payload);

                return {
                    ...initialState,
                    token: user.token,
                    user_id: user.user_id,
                    firstName: user.first_name,
                    lastName: user.last_name,
                    fullName: user.first_name + " " + user.last_name,
                    phone: user.phone,
                    suspend: user.suspend,
                    roles: user.roles,
                    permissions: user.permissions,
                    wallet_price: user.wallet_price,
                };
            } catch (e) {
                localStorage.removeItem("token");
                return state;
            }
        case 'LOGOUT':
            const obj = {...action}
            delete obj.type
            let tmp = initialState;
            tmp.token = '';
            localStorage.removeItem("token")
            return {...state, ...tmp}
        default:
            return state
    }
}

export default authReducer
